import { forwardRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useDispatch, useSelector } from 'react-redux';
import { changeRegisterForm } from 'modules/contractSlice';

const Datepicker = ({ edit }) => {
  const dispatch = useDispatch();
  const { termStartDate, termEndDate } = useSelector(
    ({ contract }) => contract.contractRegisterForm.contract,
  );
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const StartCustomInput = forwardRef(({ value, onClick }, ref) => (
    <StyledCustomInput onClick={onClick} ref={ref}>
      {value}
    </StyledCustomInput>
  ));
  const EndCustomInput = forwardRef(({ value }, ref) => (
    <StyledCustomInput ref={ref}>{value}</StyledCustomInput>
  ));

  useEffect(() => {
    const date = new Date(startDate);
    date.setFullYear(date.getFullYear() + 3);
    date.setDate(date.getDate() - 1);
    setEndDate(date);
  }, [startDate]);

  useEffect(() => {
    if (!edit) {
      dispatch(
        changeRegisterForm({
          form: 'contract',
          key: 'termStartDate',
          value: new Date(startDate).toDateString(),
        }),
      );
      dispatch(
        changeRegisterForm({
          form: 'contract',
          key: 'termEndDate',
          value: new Date(endDate).toDateString(),
        }),
      );
    }
  }, [edit, dispatch, startDate, endDate, termStartDate, termEndDate]);

  useEffect(() => {
    if (edit && termStartDate) {
      setStartDate(new Date(termStartDate));
    }
  }, [edit, termStartDate, termEndDate]);

  return (
    <>
      <div style={{ width: 220 }}>
        <DatePicker
          dateFormat="yyyy-MM-dd"
          selected={startDate}
          onChange={date => {
            setStartDate(date);
            dispatch(
              changeRegisterForm({
                form: 'contract',
                key: 'termStartDate',
                value: date.toISOString().split('T')[0],
              }),
            );
            const newDate = new Date(date);
            newDate.setFullYear(newDate.getFullYear() + 3);
            newDate.setDate(newDate.getDate() - 1);
            dispatch(
              changeRegisterForm({
                form: 'contract',
                key: 'termEndDate',
                value: newDate.toISOString().split('T')[0],
              }),
            );
          }}
          customInput={<StartCustomInput />}
        />
      </div>
      <div style={{ fontSize: 20 }}>~</div>
      <div style={{ width: 220 }}>
        <DatePicker
          dateFormat="yyyy-MM-dd"
          selected={endDate}
          customInput={<EndCustomInput />}
        />
      </div>
    </>
  );
};

export default Datepicker;

const StyledCustomInput = styled.button`
  width: 100%;
  height: 40px;
  background: #fff;
  border: none;
  border: solid 1px #dfdfdf;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
`;
